import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'baq_page' */ './QuoteDetails'),
);
